/**
 * Labstep
 *
 * @module components/ExperimentWorkflow/Action/Sign
 * @desc Action to sign signature
 */

import { EntityUpdateContainer } from 'labstep-web/containers/Entity/Update';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { generateNewDateString } from 'labstep-web/services/date.service';
import type React from 'react';
import type { ISignatureActionRevokeProps } from './types';

export const SignatureActionRevoke: React.FC<
  ISignatureActionRevokeProps
> = ({ signature, experimentWorkflow }) =>
  (!signature.revoked_at &&
    experimentWorkflow.allowed_actions.includes('*')) ||
  experimentWorkflow.allowed_actions.includes('signature:edit') ? (
    <EntityUpdateContainer
      entityName={signature.entityName}
      id={signature.id}
    >
      {({ update, status }) => (
        <ActionComponent
          icon="times"
          type="option"
          text="Revoke"
          status={status}
          onClick={() => {
            update({ revoked_at: generateNewDateString() });
          }}
        />
      )}
    </EntityUpdateContainer>
  ) : null;
